import React from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useLang } from "@/i18n";
import { LEGAL, LEGAL_ORDER, LEGAL_UPDATED } from "@/lib/legalContent";

export default function Legal() {
  const { slug } = useParams();
  const { t, lang } = useLang();
  const legal = LEGAL[lang];
  const doc = legal[slug] || legal["terms"];

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
      <div className="grid md:grid-cols-[220px_1fr] gap-8">
        <aside className="md:sticky md:top-24 h-max">
          <Link to="/" className="inline-flex items-center gap-1 text-stone-500 font-semibold mb-4 hover:text-primary"><ChevronLeft size={18} /> Betool</Link>
          <nav className="space-y-1">
            {LEGAL_ORDER.map((s) => (
              <Link key={s} to={`/legal/${s}`} data-testid={`legal-nav-${s}`}
                className={`block px-3 py-2 rounded-xl text-sm font-medium ${s === (slug || "terms") ? "bg-primary/10 text-primary" : "text-stone-600 hover:bg-stone-100"}`}>
                {legal[s].title}
              </Link>
            ))}
          </nav>
        </aside>
        <article className="bg-white rounded-3xl border-2 border-stone-200 p-6 sm:p-9" data-testid="legal-content">
          <div className="mb-6 p-4 rounded-2xl bg-secondary/60 text-sm text-stone-700">{t("legal_review_note")}</div>
          <h1 className="font-head font-black text-3xl sm:text-4xl mb-2">{doc.title}</h1>
          <p className="text-stone-400 text-sm mb-8">{t("legal_updated")}: {LEGAL_UPDATED}</p>
          <div className="space-y-6">
            {doc.sections.map((sec, i) => (
              <section key={i}>
                <h2 className="font-head font-bold text-xl mb-1.5">{sec.h}</h2>
                <p className="text-stone-700 leading-relaxed">{sec.p}</p>
              </section>
            ))}
          </div>
        </article>
      </div>
    </div>
  );
}
